<template>
  <div class="container-fluid" style="margin-top: 0">
    <div class="row-fluid">
      <!--最新活动-->
      <div class="span12 text-left">
        <div class="cent" v-if="list == ''">暂无订单</div>

        <div
          class="jumbotron_c t_20"
          v-for="(item, index) in list"
          v-else
          :key="index"
          @click="route(item.id, item.content_id)"
        >
          <div class="row">
            <div class="col-3" style="padding-right: 0px">
              <div style="padding: 10px 0px 10px 10px">
                <img
                  style="width: 100%; height: 70px"
                  :src="item.content_images"
                />
              </div>
            </div>
            <div class="col-9">
              <h5>{{ item.content_name }}</h5>
              <span
                class="text-right"
                style="
                  font-size: 80%;
                  color: #6c757d;
                  display: block;
                  margin-top: -24px;
                  margin-right: 10px;
                "
                >￥{{ item.integral }}积分</span
              >
              <div style="height: 5px"></div>
              <footer class="blockquote-footer">
                {{ item.username }} {{ item.telephone }}
              </footer>
              <h5
                class="text-right"
                style="margin-bottom: 0px; padding-top: 10px"
              >
                <span class="label label-primary-j">详细信息</span>
              </h5>
            </div>
          </div>
        </div>
        <div v-if="list != ''">
          <button
            v-if="moreShowBoolen"
            @click="moreShow1"
            class="btn_page btn1"
            style="
              display: block;
              margin: 25px auto 0;
              outline: none;
              color: #666;
              background-color: #eee;
              border-radius: 25px;
              height: 30px;
              width: 60%;
            "
          >
            更多选项
          </button>
          <div v-else style="text-align: center; margin-top: 15px">
            已无更多
          </div>
        </div>
        <!-- <div class="jumbotron_c t_20">
          <div class="row">
            <div class="col-3" style="padding-right:0px;">
              <div style="padding:10px 0px 10px 10px;">
                <img style="width: 100%; height: 70px;" src="https://img.hsnms.com/20210807/1628335448.jpg" />
              </div>
            </div>
            <div class="col-9">
              <h5 class="h5_t_5"><span class="label label-primary label_50">主要标签</span> 是服务队伍的聚集地</h5>
              <footer class="blockquote-footer">From WWF's website</footer>
              <h5 class="text-right" style="margin-bottom:0px; padding-top: 3px;"><span
                  class="label label-primary-j">详细信息</span></h5>
            </div>
          </div>
        </div> -->

        <div id="d_p"></div>
      </div>
    </div>
  </div>
</template>
<script>
import user_model from "../tool/user_model";
export default {
  data() {
    return {
      list: [],
      nowPage: 1,
      moreShowBoolen: false,
      nowPage_t: 1,
    };
  },
  components: {},
  props: {},
  created() {},
  mounted() {
    this.moreShow1();
    // http://dns1.hsnms.com:17074/app/mutual/order/?appid=202108&type_id=6001&openid=用户openid
    // const info = user_model.getUserinfo()
    // this.$api.getAPI("mutual/order/?appid=202108&type_id=6001&state=1", {
    //   openid: info.openid
    // }).then(res => {
    //   // console.log(res);
    //   this.list = res.data.data.data[0].models
    //   console.log(this.list);
    // })
  },
  methods: {
    moreShow1() {
      // 点击查询更多
      const info = user_model.getUserinfo();
      this.$api
        .getAPI("mutual/order/?appid=202108&type_id=6001&size=10", {
          page: this.nowPage,
          openid: info.openid,
        })
        .then((res) => {
          for (let i = 0; i < res.data.data.data[0].models.length; i++) {
            this.list.push(res.data.data.data[0].models[i]);
          }
          var db = res.data.data.data[0];
          this.nowPage_t = db.page.count;
          this.moreShowBoolen = true;
          if (this.nowPage_t < this.nowPage * 10) {
            this.moreShowBoolen = false;
          }
          this.nowPage++;
        });
    },
    route(id, cid) {
      // @click="$router.push('/mall_show')"
      // console.log(id);
      this.$router.push({
        name: "details",
        query: {
          id: id,
          cid: cid,
        },
      });
    },
  },
};
</script>

<style>
.cent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #777;
  font-size: 20px;
}
.btn1 {
  border: none;
  outline: 0;
  background: none;
}
.jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}

.label_50 {
  border-radius: 50px/50px;
}

.page-header {
  margin: 25px 0 0px;
}

.h5_t_5 {
  margin-top: 15px;
}

.b_t_5 {
  padding-top: 6px;
}

.border_ {
  background: #002752;
}

.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -40px;
}

.carousel-indicators li {
  background-color: #000000;
}

.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}

.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}

.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}

.jumbotron_b {
  color: #fff;
  background: #3480fa;
}

.jumbotron_c {
  background: #f3f4f8;
}

.carousel-indicators li {
  width: 8px;
  height: 8px;
  background-color: #00cdc6;
}

.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 8px;
}

.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}

.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user_order_list.vue